













































































import Vue from 'vue';
import LaborDayTimeline from '@/parts/labor/LaborDayTimeline.vue';
import LaborRegistWorkReport from '@/parts/labor/LaborRegistWorkReport.vue';
import * as WorkstyleModels from '@/class/models/views/setting/workstyle';
import { VLabor } from '@/class/models/views/labor';

import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { AttendanceType, AbsenceType, PaidLeaveType } from '@/class/common/const/labor-const';

import { ILaborRequest } from '@/class/models/typed/labor';
import { ILaborCalendarEvent } from '@/class/models/typed/labor';
import API, { ApiResult } from '@/api/common';
import { IWorkCategoryUser } from '@/class/models/typed/work-category';
import { formatYmd, formatYm, parseYmd } from '@/class/common/util/date_util';
import { LABOR_ERRORS } from '@/class/common/const/labor-error';
import { ApiErrorPayload } from '@/class/common/type/api-error';
import { LABOR_VALIDATION_CODES } from '@/util/laborValidationCodes';
import * as usermodels from '@/class/models/views/setting/users';
import * as models from '@/class/models/views/setting/workstyle';
import { ICustomHolidayView } from '@/class/models/typed/custom-holiday';
import { routerPush } from '@/util/vue-router-util';

interface IOption {
  id: number;
  value: number;
  text: string;
}

function toModalEditForm(apiEvent: ILaborCalendarEvent) {
  let kind = 'absence';
  if (apiEvent.attendanceType === AttendanceType.ATTENDANCE) {
    kind = 'work';
  } else if (apiEvent.attendanceType === AttendanceType.LATE_EARLY) {
    kind = 'late-early';
  }

  let absenceKind = 'absence';
  if (apiEvent.absenceType === AbsenceType.PAID_LEAVE) {
    absenceKind = 'paidLeave';
  } else if (apiEvent.absenceType === AbsenceType.SPECIAL_LEAVE) {
    absenceKind = 'timeOff';
  }

  // 有給種別（全日/半日）の判定
  const paidLeaveKind =
    apiEvent.paidLeaveType === PaidLeaveType.HALF_DAY // 例: "half-day" または Enum
      ? 'half-day'
      : 'full-day';

  return {
    kind,
    absenceKind,
    paidLeaveKind,
    start: apiEvent.startTime ? apiEvent.startTime : '09:00',
    end: apiEvent.endTime ? apiEvent.endTime : '18:00',
    taskId: apiEvent.workCategoryId,
    specialLeaveId: apiEvent.specialLeaveId,
    timeOffStart: apiEvent.startYmd ? apiEvent.startYmd : undefined,
    timeOffEnd: apiEvent.endYmd ? apiEvent.endYmd : undefined,
    description: apiEvent.description ? apiEvent.description : '',
  };
}

const api = new API();

interface Data {
  showModal: boolean;
  taskOptions: IOption[];
  modalKey: number;
  modalOpenedBy: 'new' | 'edit' | '';
  date: Date;
  eventsByDate: { [date: string]: any[] };
  specialLeaves: WorkstyleModels.ISpecialLeave[];
  editingEvent?: any;
  showDeleteModal: boolean;
  deleteTarget?: any;
  initialForm?: any;
  modalServerErrors: {
    periodError?: string;
    timeError?: string;
    taskError?: string;
    descriptionError?: string;
  };
  userProfile: any;
  selectedDate: string;
  customHolidays: ICustomHolidayView[];
}

interface Methods {
  buildDateTime(dateStr: string, time?: string): string | undefined;
  buildAllDayRange(
    startDate: Date,
    endDate?: Date,
  ): {
    periodStart: string;
    periodEnd: string;
  };
  openModal(): void;
  closeModal(): void;
  handleUpdate(local: any): void;
  handleAddAnother(payload: any): void;
  setDate(d: Date): void;
  onEdit(ev: any): void;
  onRemove(ev: any): void;
  confirmRemove(): void;
  closeDeleteModal(): void;
  applyRouteQuery(): void;
  findTaskTitle(taskID: number | undefined): string;
  toTimelineEvent(apiEvent: ILaborCalendarEvent): void;
  saveLabor(local: any, isEdit?: boolean): Promise<void>;
  addMinutesToTime(time: string, minutes: number): string;
  reloadDayEvents(baseDate: Date): Promise<void>;
  buildLaborRequest(local: any): ILaborRequest;
}

interface Computed {
  dayEvents: any[];
  timeOffOptions: IOption[];
}

export default Vue.extend({
  name: 'LaborRegistDaily',
  data() {
    const taskOptions: IOption[] = [];
    return {
      customHolidays: [] as ICustomHolidayView[],
      selectedDate: '',
      selectCalenderDate: undefined as Date,
      modalServerErrors: {
        periodError: '',
        timeError: '',
        taskError: '',
        descriptionError: '',
      },
      LABOR_ERRORS,
      showModal: false,
      taskOptions,
      modalKey: 0, // 再表示でフォームをリセットするためのキー
      modalOpenedBy: '',
      date: new Date(),
      eventsByDate: {} as any,
      specialLeaves: [],
      editingEvent: undefined,
      showDeleteModal: false,
      deleteTarget: undefined,
      initialForm: undefined,
      userProfile: {} as any,
    };
  },
  async mounted() {
    try {
      this.$emit('loading', true);
      this.$emit('pushPath', this.$route.path);
      const resHoriday = await api.get<WorkstyleModels.ISpecialLeave[]>('workstyle/specialleave');

      const resCustomHoliday = await api.get<models.VCustomHolidayList>('workstyle/customholiday');
      const customHolidays =
        resCustomHoliday.data && Array.isArray(resCustomHoliday.data.customHolidays)
          ? resCustomHoliday.data.customHolidays
          : [];
      this.customHolidays = customHolidays;

      const workCategories = await api.get<IWorkCategoryUser[]>('workmanage/work_category_by_user_id');

      if (workCategories.data.length === 0) {
        console.error('error workCategories');
      }
      const resUser = await api.get<usermodels.VEditUserProfile>('users/login_user_data');
      if (!resUser.data || !resUser.data.user) {
        console.error('error user');
        this.$emit('errorModal', 'エラーが発生しました。');
        this.$emit('loading', false);
        return;
      }
      this.userProfile = resUser.data.user;

      this.taskOptions = workCategories.data.map(c => ({
        id: c.id,
        value: c.id,
        text: c.name,
      }));

      // REMOLABO-1228 環境ごとの遷移先変更の際にクエリの上書きを避けるため、pathが違えば何もしない
      if (this.$route.path.indexOf('/labor/regist/daily') === 0) {
        this.applyRouteQuery();
      }
      this.specialLeaves = resHoriday.data;
    } catch (e) {
      console.error('errorCatchHoge ' + e);
      this.$emit('errorModal', 'エラーが発生しました。');
      return;
    } finally {
      this.$emit('loading', false);
    }
  },
  beforeDestroy() {
    console.info(`destroy`);
    this.$emit('loading', false);
  },
  watch: {
    '$route.query.date': {
      immediate: false,
      handler() {
        this.applyRouteQuery();
      },
    },
  },
  computed: {
    dayEvents: {
      get(): any[] {
        const key = formatYmd(this.date);
        return this.eventsByDate[key] || [];
      },
      set(val: any[]) {
        const key = formatYmd(this.date);
        this.$set(this.eventsByDate, key, val);
      },
    },
    // UI用に整形した配列を computed で用意
    timeOffOptions(): IOption[] {
      return this.specialLeaves.map(item => ({
        id: item.specialLeaveID,
        value: item.specialLeaveID,
        text: item.name,
      }));
    },
  },
  methods: {
    async reloadDayEvents(baseDate: Date) {
      const start = new Date(baseDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(start);
      end.setDate(end.getDate() + 1);

      const periodStart = formatYmd(start);
      const periodEndExclusive = formatYmd(end);

      const res = await api.get<ILaborCalendarEvent[]>('labor/daily_reports', {
        periodStart,
        periodEndExclusive,
      });

      if (Array.isArray(res.data)) {
        this.dayEvents = res.data.map(ev => this.toTimelineEvent(ev)).filter(ev => ev !== null);
      } else {
        this.dayEvents = [];
      }
    },
    // null ではなく undefined を返す
    buildDateTime(dateStr: string, time?: string): string | undefined {
      if (!time) {
        return undefined;
      }
      return `${dateStr} ${time}:00`;
    },
    // 終日/期間休暇用
    buildAllDayRange(startDate: Date, endDate?: Date) {
      const effectiveDate = endDate ? new Date(endDate) : new Date(startDate);
      const startStr = formatYmd(startDate);
      const endStr = formatYmd(effectiveDate);
      return {
        periodStart: `${startStr} 00:00:00`,
        periodEnd: `${endStr} 23:59:59`,
      };
    },
    openModal() {
      // 新規登録モード
      this.modalServerErrors = {} as any;
      this.editingEvent = undefined;
      this.modalOpenedBy = 'new';
      this.modalKey += 1; // 中身リセット用
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editingEvent = undefined;
      this.modalOpenedBy = '';
    },
    onClickHeader() {
      const formattedMonth = formatYm(this.selectCalenderDate);
      routerPush(this.$router, {
        name: 'RegistMonthly',
        query: {
          month: formattedMonth,
        },
      });
    },

    async applyRouteQuery() {
      const { new_report } = this.$route.query;
      const { date } = this.$route.query;
      if (typeof date === 'string') {
        this.selectedDate = date;
      } else {
        this.selectedDate = '';
      }
      let baseDate: Date;
      let shouldReplaceUrl = false;

      // 1. baseDate を決める
      if (typeof date === 'string') {
        const parsed = parseYmd(date);
        if (parsed) {
          baseDate = parsed;
        } else {
          baseDate = new Date();
          shouldReplaceUrl = true;
        }
      } else {
        // dateクエリが存在しない場合
        baseDate = new Date();
        shouldReplaceUrl = true;
      }

      // 未来の日付を指定された場合は今日に置き換える
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      baseDate.setHours(0, 0, 0, 0);

      if (baseDate > today) {
        baseDate = today;
        shouldReplaceUrl = true;
      }

      const endDate = new Date(baseDate);
      endDate.setDate(baseDate.getDate() + 1);

      const periodStart = formatYmd(baseDate);
      const periodEndExclusive = formatYmd(endDate);

      const res = await api.get<ILaborCalendarEvent[]>('labor/daily_reports', {
        periodStart,
        periodEndExclusive,
      });

      // 日付をセット
      this.date = baseDate;
      this.selectCalenderDate = baseDate;

      // 3. レスポンスデータをタイムライン形式に変換してセット
      if (res.data && Array.isArray(res.data)) {
        const formattedEvents = res.data.map(ev => this.toTimelineEvent(ev)).filter(ev => ev !== null);

        // computedのsetterが呼ばれ、eventsByDateに格納される
        this.dayEvents = formattedEvents;
      } else {
        this.dayEvents = [];
      }
      if (new_report) {
        this.openModal();
        shouldReplaceUrl = true;
      }

      if (shouldReplaceUrl) {
        this.$router.replace({
          name: this.$route.name!,
          query: {
            date: periodStart,
          },
        });
      }
    },
    findTaskTitle(taskId: number | undefined): string {
      if (taskId === undefined) {
        return '';
      }
      const hit = this.taskOptions.find(t => t.value === taskId);
      return hit ? hit.text : '';
    },
    toTimelineEvent(apiEvent: ILaborCalendarEvent) {
      // 1. 編集用フォームデータ（snapshot）作成
      const snapshot = toModalEditForm(apiEvent);

      // 2. タイムライン表示に必要な共通プロパティ
      const timelineItem: any = {
        id: apiEvent.id,
        form: snapshot,
        note: apiEvent.description,
        description: apiEvent.description,
      };

      if (snapshot.kind === 'work') {
        return {
          ...timelineItem,
          kind: 'work',
          start: snapshot.start,
          end: snapshot.end,
          title: apiEvent.workCategoryName,
          taskId: apiEvent.workCategoryId,
        };
      } else if (snapshot.kind === 'late-early') {
        return {
          ...timelineItem,
          kind: 'absence',
          start: snapshot.start,
          end: snapshot.end,
          isAllDay: false,
          absenceType: '遅刻・早退',
        };
      } else if (snapshot.kind === 'absence') {
        let absenceType = '欠勤';
        let isAllDay = true;
        let start = '09:00';
        let end = '18:00';

        if (snapshot.absenceKind === 'paidLeave') {
          if (snapshot.paidLeaveKind === 'half-day') {
            absenceType = '有給（半日）';
            isAllDay = false;
            start = snapshot.start;
            end = snapshot.end;
          } else {
            absenceType = '有給';
            isAllDay = true;
          }
        } else if (snapshot.absenceKind === 'timeOff') {
          absenceType = apiEvent.specialLeaveName;
          isAllDay = true;
        }
        return {
          ...timelineItem,
          kind: 'absence',
          start,
          end,
          isAllDay,
          absenceType,
        };
      }

      return undefined;
    },
    async handleUpdate(local: any) {
      const isEdit = !!this.editingEvent; // 編集モードかどうか
      const body = this.buildLaborRequest(local);
      let res: any;
      try {
        if (isEdit && this.editingEvent) {
          res = await api.put<ILaborRequest, VLabor>(`labor/daily_report/${this.editingEvent.id}`, body, {
            throwOnError: true,
          });
        } else {
          res = await api.post<ILaborRequest, VLabor>('labor/daily_report', body, { throwOnError: true });
        }
      } catch (error) {
        const err = error as ApiErrorPayload;
        this.modalServerErrors = {} as any;

        if ('validationCodes' in err) {
          const codes = new Set(err.validationCodes);
          if (
            codes.has(LABOR_VALIDATION_CODES.PERIOD_START_REQUIRED) &&
            codes.has(LABOR_VALIDATION_CODES.PERIOD_END_REQUIRED)
          ) {
            this.modalServerErrors.timeError = '開始時間と終了時間を入力してください';
          } else {
            if (codes.has(LABOR_VALIDATION_CODES.PERIOD_START_REQUIRED)) {
              this.modalServerErrors.timeError = '開始時間を入力してください';
            }
            if (codes.has(LABOR_VALIDATION_CODES.PERIOD_END_REQUIRED)) {
              this.modalServerErrors.timeError = '終了時間を入力してください';
            }
          }

          if (codes.has(LABOR_VALIDATION_CODES.DESCRIPTION_MAX)) {
            this.modalServerErrors.descriptionError = '256文字以内で入力してください';
          } else if (codes.has(LABOR_VALIDATION_CODES.DESCRIPTION_EMOJI_NOT_ALLOWED)) {
            this.modalServerErrors.descriptionError = '絵文字の入力はできません';
          }
          return;
        }

        // 型ガード 通常エラー
        if ('code' in err) {
          if (err.code === LABOR_ERRORS.TIME_OVERLAP) {
            this.modalServerErrors = {
              periodError: '他の勤怠と期間が重複しています',
            } as any;
            return;
          }
        }
      }

      await this.reloadDayEvents(this.date);
      this.editingEvent = undefined;
      this.showModal = false;
    },

    async saveLabor(local: any, isEdit?: boolean) {
      const body = this.buildLaborRequest(local);
      let res: ApiResult<{ id: number }>;

      if (isEdit && this.editingEvent) {
        res = await api.put(`labor/daily_report/${this.editingEvent.id}`, body);
      } else {
        res = await api.post('labor/daily_report', body);
      }

      await this.reloadDayEvents(this.date);
    },

    async handleAddAnother(payload: any) {
      // 保存（編集 or 新規）
      const isEdit = !!this.editingEvent;
      await this.saveLabor(payload, isEdit);
      const nextStart = payload.end || '09:00';
      const nextEnd = this.addMinutesToTime(nextStart, 60);
      this.editingEvent = undefined;

      const newInitialForm = {
        kind: 'work',
        absenceKind: 'paidLeave',
        paidLeaveKind: 'full-day',
        start: nextStart,
        end: nextEnd,
        taskId: undefined,
        description: '',
      };

      this.showModal = false;
      this.$nextTick(() => {
        this.editingEvent = undefined;
        this.modalKey += 1; // フォーム初期化
        this.initialForm = newInitialForm; // モーダルに渡す
        // this.showModal = true;
      });
    },
    addMinutesToTime(time: string, minutes: number) {
      if (!time) {
        return time;
      }
      const [hh, mm] = time.split(':').map(Number);
      const t = new Date(0, 0, 0, hh, mm + minutes);
      const h = String(t.getHours()).padStart(2, '0');
      const m = String(t.getMinutes()).padStart(2, '0');
      return `${h}:${m}`;
    },

    setDate(d: Date) {
      const ymd = formatYmd(d);
      routerPush(this.$router, {
        name: this.$route.name!,
        query: {
          ...this.$route.query,
          date: ymd,
        },
      });
    },
    onEdit(ev: any) {
      // タイムラインから渡ってきたイベントを保持してモーダル表示
      const form = { ...ev.form };

      if (form.timeOffStart && typeof form.timeOffStart === 'string') {
        form.timeOffStart = new Date(form.timeOffStart);
      }
      if (form.timeOffEnd && typeof form.timeOffEnd === 'string') {
        form.timeOffEnd = new Date(form.timeOffEnd);
      }

      this.editingEvent = {
        ...ev,
        form,
      };
      this.modalOpenedBy = 'edit';
      this.modalKey += 1;
      this.showModal = true;
    },
    onRemove(ev: any) {
      this.deleteTarget = ev;
      this.showDeleteModal = true;
    },
    // 削除確定
    async confirmRemove() {
      if (!this.deleteTarget) {
        return;
      }
      try {
        await api.delete(`labor/daily_report/${this.deleteTarget.id}`);
        this.dayEvents = this.dayEvents.filter(e => e.id !== this.deleteTarget.id);
        this.showDeleteModal = false;
        this.deleteTarget = undefined;
      } catch (error) {
        console.error(error);
      }
    },
    // 削除キャンセル（モーダルクローズ）
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.deleteTarget = undefined;
    }, // 関数単位でルールを無視
    /* tslint:disable:no-shadowed-variable */ buildLaborRequest(local: any): ILaborRequest {
      const dateStr = formatYmd(this.date);
      const commonPayload = {
        description: local.description,
      };
      switch (local.kind) {
        case 'work':
          return {
            ...commonPayload,
            attendanceType: AttendanceType.ATTENDANCE,
            periodStart: this.buildDateTime(dateStr, local.start),
            periodEnd: this.buildDateTime(dateStr, local.end),
            taskId: local.taskId,
            absenceKind: undefined,
            paidLeaveKind: undefined,
            specialLeaveId: undefined,
          };

        case 'absence':
          if (local.absenceKind === 'paidLeave') {
            if (local.paidLeaveKind === 'half-day') {
              return {
                ...commonPayload,
                attendanceType: AttendanceType.ABSENCE,
                absenceKind: AbsenceType.PAID_LEAVE,
                periodStart: this.buildDateTime(dateStr, local.start),
                periodEnd: this.buildDateTime(dateStr, local.end),
                paidLeaveKind: PaidLeaveType.HALF_DAY,
                taskId: undefined,
                specialLeaveId: undefined,
              };
            }
            const { periodStart, periodEnd } = this.buildAllDayRange(this.date);
            return {
              ...commonPayload,
              attendanceType: AttendanceType.ABSENCE,
              absenceKind: AbsenceType.PAID_LEAVE,
              paidLeaveKind: PaidLeaveType.ALL_DAY,
              periodStart,
              periodEnd,
              taskId: undefined,
              specialLeaveId: undefined,
            };
          }

          if (local.absenceKind === 'timeOff') {
            const { periodStart, periodEnd } = this.buildAllDayRange(local.timeOffStart, local.timeOffEnd);

            return {
              ...commonPayload,
              attendanceType: AttendanceType.ABSENCE,
              absenceKind: AbsenceType.SPECIAL_LEAVE,
              specialLeaveId: local.specialLeaveId,
              paidLeaveKind: undefined,
              taskId: undefined,
              periodStart,
              periodEnd,
            };
          }
          const { periodStart, periodEnd } = this.buildAllDayRange(this.date);
          return {
            ...commonPayload,
            attendanceType: AttendanceType.ABSENCE,
            absenceKind: AbsenceType.ABSENCE,
            paidLeaveKind: undefined,
            taskId: undefined,
            specialLeaveId: undefined,
            periodStart,
            periodEnd,
          };

        case 'late-early':
          return {
            ...commonPayload,
            attendanceType: AttendanceType.LATE_EARLY,
            periodStart: this.buildDateTime(dateStr, local.start),
            periodEnd: this.buildDateTime(dateStr, local.end),
            taskId: undefined,
            absenceKind: undefined,
            paidLeaveKind: undefined,
            specialLeaveId: undefined,
          };

        default:
          throw new Error(`不正な勤怠種別です: ${local.kind}`);
      }
    },
  },
  components: {
    LaborRegistWorkReport,
    LaborDayTimeline,
  },
});
